// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1bEh7","title":"styles_title__-rJHP","subtitle":"styles_subtitle__Ux6zf"};